import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";

import {Card, Label} from "semantic-ui-react";
import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";
import {Contractor} from "../../models/contractor";


export interface ContractorCardProps {
    auftragsverwaltung: Auftragsverwaltung;
    contractor?: Contractor | null;
    handleShowContractor?: (contractor: Contractor, e: React.MouseEvent) => void;
}

@observer
export class ContractorCard extends Component<ContractorCardProps, any> {
    constructor(props: ContractorCardProps) {
        super(props);
        this.state = {};
    }

    render(): React.ReactElement | null {
        const {
            contractor,
            handleShowContractor
        } = this.props;

        if (!contractor) {
            return null;
        }

        return (
            <Card className="contractor-card"
                onClick={(event: React.MouseEvent) => {
                    event.preventDefault();
                    if (handleShowContractor) {
                        handleShowContractor(contractor, event);
                    }
                }}>
                <Card.Content>
                    <Card.Header>
                        <span>{contractor.organisation}</span>
                        <Label className="right floated" basic color="grey" size="large">{contractor.id}</Label>
                    </Card.Header>
                    <Card.Description>{`${contractor.postalCode} ${contractor.city}`}</Card.Description>
                </Card.Content>
                <Card.Content extra>
                    <Label icon="user circle" content={contractor.contact} />
                    <Label icon="mail outline" content={contractor.email} />
                </Card.Content>
            </Card>
        );
    }
}
